export const TEXT_GROUP_RESPONSE_NAME = 'textGroup';
export const QUICK_REPLY_RESPONSE_NAME = 'quickReplies';
export const AUDIO_RESPONSE_NAME = 'audio';
export const CARDS_RESPONSE_NAME = 'cards';
export const LOCATION_RESPONSE_NAME = 'location';
export const FILE_RESPONSE_NAME = 'file';
export const WAIT_RESPONSE_NAME = 'wait';
export const MAX_DETAIL_COUNT = 3;
export const ALL_CATEGORY_NAME = 'All';
export const IS_TIMEOUT_ENABLED_INPUT_NAME = 'isTimeoutEnabled';
export const TIMEOUT_INPUT_NAME = 'timeout';
export const TIMEOUT_DURATION_INPUT_NAME = 'timeoutDuration';
export const TIMEOUT_DEFAULT_VALUE = '600';
export const MAXIMUM_FILE_RESPONSE_ALLOWED = 5;
export const TIMEOUT_PORT_NAME = 'timeout';
export const FAILED_PORT_NAME = 'failed';
export const GROUP_NAME_ADVANCED_SETTINGS = 'AdvancedSettings';
export const LLM_CONFIGURATION_NAME_INPUT_NAME = 'llmConfigurationName';
export const LLM_MODEL_INPUT_NAME = 'llmModel';
export const IS_CUSTOM_LLM_MODEL_SELECTED_INPUT_NAME = 'isCustomLlmModelSelected';
export const REASONING_EFFORT_INPUT_NAME = 'reasoningEffort';
export const IS_ADVANCED_CONVERSATION_ROUTING_ENABLED_INPUT_NAME =
  'isAdvancedConversationRoutingEnabled';

export const TIMEOUT_FIELDS_NAME_LIST = [
  IS_TIMEOUT_ENABLED_INPUT_NAME,
  TIMEOUT_INPUT_NAME,
  TIMEOUT_DURATION_INPUT_NAME,
];
export const LLM_SETTINGS_FIELDS_NAME_LIST = [
  LLM_CONFIGURATION_NAME_INPUT_NAME,
  LLM_MODEL_INPUT_NAME,
  IS_CUSTOM_LLM_MODEL_SELECTED_INPUT_NAME,
  REASONING_EFFORT_INPUT_NAME,
];
export const WEBHOOK_URL_INPUT_FIELD_NAME = 'webhookUrl';
export const IS_SEMANTIC_CACHE_USED_INPUT_NAME = 'isSemanticCacheUsed';
export const INCLUDE_HISTORY_INPUT_NAME = 'includeHistory';
export const STREAM_RESPONSE_INPUT_NAME = 'streamResponse';
export const RESPONSE_FORMAT_INPUT_NAME = 'responseFormat';
export const RESPONSE_FORMAT_JSON_SCHEMA_VALUE = 'json_schema';

export const nodeColor = {
  ask: '#f7b538',
  askAttachment: '#B4A7D6',
  askMissingSlot: '#a68a64',
  callTransfer: '#ffb4a2',
  code: '#52796f',
  condition: '#77c47c',
  confirmation: '#d68c45',
  customData: '#86a984',
  empty: '#e8685a',
  end: '#cf7272',
  endWithResult: '#cf7272',
  entityExtract: '#c2ab9c',
  http: '#ffc7e9',
  intentRecognition: '#62b6cb',
  listFilter: '#476c5b',
  liveChatTransfer: '#f08080',
  say: '#e38664',
  start: '#b3edb9',
  subFlow: '#d5a6bd',
  variable: '#9fbba5',
  virtualAgent: '#90dcda',
  voiceBiometrics: '#b0bae6',
  wait: '#a88b99',
  warning: '#e5e5e5',
  connector: '#77a5b1',
  exit: '#9f3939',
  returnToStart: '#cf7272',
  generativeQuestionAnswering: '#5CD4E5',
  languageCondition: '#4755bc',
  webhookListener: '#FF9DAC',
  liveCallTransfer: '#B86161',
  aiAgent: '#38CBB0',
  askLlm: '#6cbece',
  ragAgent: '#76b2fc',
};

export const nodeNames = {
  start: 'start',
  end: 'end',
  endWithResult: 'endWithResult',
  say: 'say',
  ask: 'ask',
  askMissingSlot: 'askMissingSlot',
  askAttachment: 'askAttachment',
  http: 'http',
  variable: 'variable',
  listFilter: 'listFilter',
  customData: 'customData',
  code: 'code',
  intentRecognition: 'intentRecognition',
  liveChatTransfer: 'liveChatTransfer',
  callTransfer: 'callTransfer',
  wait: 'wait',
  subFlow: 'subFlow',
  virtualAgent: 'virtualAgent',
  condition: 'condition',
  confirmation: 'confirmation',
  voiceBiometrics: 'voiceBiometrics',
  connector: 'connector',
  exit: 'exit',
  returnToStart: 'returnToStart',
  generativeQuestionAnswering: 'generativeQuestionAnswering',
  languageCondition: 'languageCondition',
  webhookListener: 'webhookListener',
  liveCallTransfer: 'liveCallTransfer',
  aiAgent: 'aiAgent',
  askLlm: 'askLlm',
  ragAgent: 'ragAgent',
};

export const languageCodeNameMap = new Map<string, string>([
  ['tr-TR', 'Turkish'],
  ['en-US', 'English'],
  ['ar-SA', 'Arabic'],
  ['lv-LV', 'Latvian'],
  ['ru-RU', 'Russian'],
  ['es-ES', 'Spanish'],
  ['ur-PK', 'Urdu'],
  ['fr-FR', 'French'],
  ['nl-NL', 'Dutch'],
  ['de-DE', 'German'],
  ['it-IT', 'Italian'],
]);
